module.exports = __webpack_public_path__ + "static/media/wallpaper4.d2d9dcec.webp";